type CurrencyConfig = {
  fractionDigits?: number
  trailingZeroDisplay?: 'auto' | 'stripIfInteger'
}

const defaults: Required<CurrencyConfig> = {
  fractionDigits: 2,
  trailingZeroDisplay: 'stripIfInteger',
}

export const currency = (val: number, config: CurrencyConfig = defaults) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: config.fractionDigits,
    trailingZeroDisplay: config.trailingZeroDisplay,
  }).format(val)
}

/**
 * rounds a currency amount to a displayable string value
 * @param amount the currency amount
 * @returns the amount rounded to hundredths or a whole number if .00 as a string
 *
 * note: this does not localize, it only formats us style numbers
 *
 * ex:
 * 123.456 => "123.46"
 * 123.00 => "123"
 * 123.5 => "123.50"
 * 123.999 => "124"
 * 123.995 => "124"
 * 1234.995 => "1,234"
 */
export function roundCurrency(amount: number) {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    trailingZeroDisplay: 'stripIfInteger',
  }).format(amount)
}
